'use client';

import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { Show } from '@/components/ui/show';
import dynamic from 'next/dynamic';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { Loader } from '../common/loaders/loaders';
import { useUser } from '@/modules/user/user.queries';

const SendOTP = dynamic(() => import('@/components/send-otp'), {
  loading: () => (
    <div className='flex items-center justify-center'>
      <Loader className='w-8 h-8 text-ruby' />
    </div>
  ),
});
const CheckOTP = dynamic(() => import('@/components/check-otp'), {
  loading: () => (
    <div className='flex items-center justify-center'>
      <Loader className='w-8 h-8 text-ruby' />
    </div>
  ),
});

export function SignIn() {
  const router = useRouter();
  const searchParams = useSearchParams();

  const isVerifying = searchParams.get('verifying') === 'true';
  const phone = searchParams.get('phone');

  useEffect(() => {
    if (isVerifying && (!phone || !isValidPhoneNumber(phone))) {
      const query = new URLSearchParams(searchParams);
      query.set('verifying', 'false');
      query.delete('phone');
      router.push(`?${query}`);
    }
  }, [isVerifying, phone, router, searchParams]);

  return (
    <>
      <Show condition={!isVerifying}>
        <SendOTP />
      </Show>

      <Show condition={isVerifying}>
        <CheckOTP />
      </Show>
    </>
  );
}
